import { ActionBase } from "./ActionBase";

export const ACTIVITY_ACTION = '[Application] Application Activity';

export class ActivityAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ACTIVITY_ACTION;
}



// WEBPACK FOOTER //
// ./src/app/core/store/action/ActivityAction.ts